import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

import { MainService } from "src/app/app.service";
import { Area, AreaPayload, AreaUsage } from "src/app/interfaces/area";

@Injectable()
export class AreaService {
  private readonly baseUrl = "/api/v2/area";

  constructor(
    private http: HttpClient,
    private mainService: MainService,
  ) {}

  list(): Observable<Array<Area>> {
    return this.http
      .get<Array<any>>(this.baseUrl, this.mainService.httpOptions)
      .pipe(map((res) => (res ?? []).map(this.normalize)));
  }

  create(payload: AreaPayload): Observable<Area> {
    return this.http.post<any>(this.baseUrl, payload, this.mainService.httpOptions).pipe(map(this.normalize));
  }

  update(id: string, payload: Partial<AreaPayload>): Observable<Area> {
    return this.http.put<any>(`${this.baseUrl}/${id}`, payload, this.mainService.httpOptions).pipe(
      map(this.normalize),
      tap(() => this.refreshSessionIfMyArea(id)),
    );
  }

  private refreshSessionIfMyArea(id: string): void {
    if (id && this.mainService.userToken?.areaID === id) {
      this.mainService.refreshSessionArea?.().subscribe();
    }
  }

  usage(id: string): Observable<AreaUsage> {
    return this.http.get<AreaUsage>(`${this.baseUrl}/${id}/usage`, this.mainService.httpOptions);
  }

  /** Com toAreaId, o servidor move as referências da área (recursos, hosts, spots e receitas) para ela antes de excluir. */
  remove(id: string, toAreaId?: string): Observable<unknown> {
    const options = toAreaId ? { ...this.mainService.httpOptions, params: { toArea: toAreaId } } : this.mainService.httpOptions;
    return this.http.delete(`${this.baseUrl}/${id}`, options);
  }

  private normalize = (raw: any): Area => ({
    id: raw?.id ?? raw?._id ?? "",
    area: raw?.area ?? "",
    restricted: !!raw?.restricted,
    tribe: raw?.tribe ? String(raw.tribe) : "",
    tribeName: raw?.tribeName ?? "",
    usersCount: raw?.usersCount ?? 0,
  });
}
